import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfirmProvider } from 'material-ui-confirm';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import cs from 'date-fns/locale/cs';

import { Router } from './routes';
import { ThemeProvider } from './theme';
import { StoreProvider } from './store/provider';
import { TrpcProvider } from './api/trpc';
import { LocaleProvider } from './utils/locale-provider';
import { ErrorBoundary } from './utils/error-boundary';
import { IframeResizeObserver } from './utils/iframe-resize-observer';

import './utils/url-layout-modes';
import './utils/web-notifications';
import './utils/portal-tools';

export const Main = () => {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <StoreProvider>
          <LocaleProvider>
            <TrpcProvider>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={cs}
              >
                {/* eslint-disable-next-line */}
                {/* @ts-ignore */}
                <ConfirmProvider useLegacyReturn>
                  <IframeResizeObserver>
                    <BrowserRouter>
                      <Router />
                    </BrowserRouter>
                  </IframeResizeObserver>
                </ConfirmProvider>
              </LocalizationProvider>
            </TrpcProvider>
          </LocaleProvider>
        </StoreProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
};
